import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Resets the scroll position when the route changes, unless jumping to an in-page anchor. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
